import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, } from "react";
import { ElxIconButton, ElxTextField, } from "@elixir/components";
import { Checkbox, ContextualMenu, Modal, Stack, } from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";
import { CustomerSearch } from "../../commoncomponents/CustomerSearch";
import { useLocaleStrings } from "../../library/providers/strings";
import { useCustomerDataDispatch, } from "../../reducers/CustomerSearchContext/CustomerSearchContextProvider";
import CustomerSearchResult from "./CustomerSearchResult";
import AutoSuggestSearchBox from "../SearchWithSuggestions/AutoSuggestSearch";
import { SearchType } from "../../models";
import PartnerSearch from "./PartnerSearch";
const CustomerSearchContainer = ({ selectedSearchResult, resultDispatch, errorMessage, searchType, manualCustomerPlaceholder, deduplicateByTpid, hideSalesId, hideEmptyResultFields, }) => {
    var _a, _b, _c, _d;
    const { getLocalSpecificString } = useLocaleStrings();
    const { GetCustomerData, GetPartnerData } = useCustomerDataDispatch();
    const [isInitialized, setIsInitialized] = useState(true);
    const [isManualModeSticky, setIsManualModeSticky] = useState(null);
    const [suggestions, setSuggestions] = useState(searchType === SearchType.Customer
        ? selectedSearchResult.customerData.msSalesID == "0"
            ? false
            : true
        : ((_a = selectedSearchResult.partnerData) === null || _a === void 0 ? void 0 : _a.partnerId) == "0"
            ? false
            : true);
    const [companyOrPartnerName, setCompanyOrPartnerName] = useState(searchType === SearchType.Customer
        ? selectedSearchResult.customerData.companyName || ""
        : ((_b = selectedSearchResult.partnerData) === null || _b === void 0 ? void 0 : _b.partnerName) || "");
    const [isModalOpen, { setTrue: showModal, setFalse: hideModal }] = useBoolean(false);
    const [isDraggable, { toggle: toggleIsDraggable }] = useBoolean(true);
    const dragOptions = {
        moveMenuItemText: "Move",
        closeMenuItemText: "Close",
        menu: ContextualMenu,
        dragHandleSelector: ".ms-Modal-scrollableContent > div:first-child",
    };
    const [searchCriteria] = useState({
        filters: {},
        keyword: "",
    });
    useEffect(() => {
        if (isInitialized)
            setIsInitialized(false);
    }, []);
    useEffect(() => {
        if (!isInitialized) {
            setCompanyOrPartnerName("");
            hideModal();
        }
    }, [searchType]);
    useEffect(() => {
        var _a, _b;
        // Keep local UI state aligned when parent restores saved search/manual state.
        const shouldUseSuggestionsFromParent = searchType === SearchType.Customer
            ? selectedSearchResult.customerData.msSalesID != "0"
            : ((_a = selectedSearchResult.partnerData) === null || _a === void 0 ? void 0 : _a.partnerId) != "0";
        const shouldUseSuggestions = isManualModeSticky === null
            ? shouldUseSuggestionsFromParent
            : !isManualModeSticky;
        const restoredName = searchType === SearchType.Customer
            ? selectedSearchResult.customerData.companyName || ""
            : ((_b = selectedSearchResult.partnerData) === null || _b === void 0 ? void 0 : _b.partnerName) || "";
        setSuggestions(shouldUseSuggestions);
        setCompanyOrPartnerName(restoredName);
    }, [selectedSearchResult, searchType, isManualModeSticky]);
    const onChange = (searchText, search) => {
        var _a, _b;
        if (!isInitialized) {
            if (searchType === SearchType.Customer) {
                if ((_a = selectedSearchResult.customerData) === null || _a === void 0 ? void 0 : _a.companyName)
                    resultDispatch({ customerData: {} });
            }
            else {
                if ((_b = selectedSearchResult.partnerData) === null || _b === void 0 ? void 0 : _b.partnerName)
                    resultDispatch({
                        partnerData: {},
                    });
            }
            if (searchText.trim().length >= 3)
                return search(searchText);
            if (searchText.length === 0)
                void search(searchText);
        }
        return undefined;
    };
    const onSuggestionClicked = (customerData) => {
        setIsManualModeSticky(false);
        resultDispatch({
            customerData: customerData,
            partnerData: {},
        });
    };
    const onPartnerSuggestionClicked = (partnerData) => {
        setIsManualModeSticky(false);
        resultDispatch({
            customerData: {},
            partnerData: partnerData,
        });
    };
    const updateCompanyOrPartnerName = (companyOrPartnerName) => {
        var _a, _b;
        setCompanyOrPartnerName(companyOrPartnerName);
        if (searchType === SearchType.Customer) {
            setIsManualModeSticky(companyOrPartnerName.trim().length > 0);
            const customerData = {
                tpid: "",
                msSalesID: companyOrPartnerName.trim() ? "0" : "",
                accountNumber: "",
                companyName: (_a = companyOrPartnerName.trim()) !== null && _a !== void 0 ? _a : "",
                subsidiary: "",
                salesRegion: "",
                atuGroupName: "",
                atuManagerAlias: "",
                atuAccountExecutiveAlias: "",
                segment: "",
                subSegment: "",
            };
            resultDispatch({ customerData, partnerData: {} });
        }
        else {
            setIsManualModeSticky(companyOrPartnerName.trim().length > 0);
            const partnerData = {
                partnerId: companyOrPartnerName.trim() ? "0" : "",
                partnerName: (_b = companyOrPartnerName.trim()) !== null && _b !== void 0 ? _b : "",
                parentIdNumber: "",
                parentName: "",
                subsidiaryName: "",
                segmentName: "",
                subSegmentName: "",
            };
            resultDispatch({
                partnerData: partnerData,
                customerData: {},
            });
        }
    };
    return (_jsxs(Stack, Object.assign({ className: "customerSearchContainer" }, { children: [searchType === SearchType.Customer ? (suggestions && selectedSearchResult.customerData.msSalesID != "0" ? ( //check another condition for partner as well.
            _jsx(Stack.Item, Object.assign({ className: "customerSearchForm__row" }, { children: _jsxs("div", Object.assign({ className: "searchboxStyle" }, { children: [_jsx(AutoSuggestSearchBox, { className: "searchBox", objectType: "customerData" // decide based on data type.
                            , onSuggestionClicked: onSuggestionClicked, onSearchRequested: (query) => onChange(query, GetCustomerData), selectedSuggestion: selectedSearchResult.customerData, onShowAllClicked: showModal, deduplicateByTpid: deduplicateByTpid, hideSalesId: hideSalesId, placeholder: getLocalSpecificString("selectCustomerPlaceHolder"), debounceTime: 700, noResultMessage: getLocalSpecificString("noCustomerFoundOnDropdown"), ariaLabel: "Select Customer." }), !isModalOpen &&
                            selectedSearchResult.customerData.companyName && (_jsx(CustomerSearchResult, { customerData: selectedSearchResult.customerData, partnerData: {}, searchType: searchType, hideEmptyFields: hideEmptyResultFields, hideSalesId: hideSalesId }))] })) }))) : (_jsx(ElxTextField, { className: "customerNameText", placeholder: manualCustomerPlaceholder || "Please enter company name", value: companyOrPartnerName, onChange: (_ev, newValue) => {
                    updateCompanyOrPartnerName(newValue !== null && newValue !== void 0 ? newValue : "");
                } }))) : suggestions && ((_c = selectedSearchResult.partnerData) === null || _c === void 0 ? void 0 : _c.partnerId) != "0" ? (_jsx(Stack.Item, Object.assign({ className: "customerSearchForm__row" }, { children: _jsxs("div", Object.assign({ className: "searchboxStyle" }, { children: [_jsx(AutoSuggestSearchBox, { className: "searchBox", objectType: "partnerData", onSuggestionClicked: onPartnerSuggestionClicked, onSearchRequested: (query) => onChange(query, GetPartnerData), selectedSuggestion: selectedSearchResult.partnerData, onShowAllClicked: showModal, placeholder: getLocalSpecificString("selectPartnerPlaceHolder"), debounceTime: 700, noResultMessage: getLocalSpecificString("noPartnerFoundOnDropdown"), ariaLabel: "Select Partner." }), !isModalOpen &&
                            ((_d = selectedSearchResult.partnerData) === null || _d === void 0 ? void 0 : _d.partnerName) && ( //open partner search result
                        _jsx(CustomerSearchResult, { partnerData: selectedSearchResult.partnerData, customerData: {}, searchType: searchType }))] })) }))) : (_jsx(ElxTextField //set partner search changes
            , { className: "customerNameText", placeholder: "Please enter Partner Name", value: companyOrPartnerName, onChange: (_ev, newValue) => updateCompanyOrPartnerName(newValue !== null && newValue !== void 0 ? newValue : "") })), errorMessage && (_jsx("div", Object.assign({ className: "has-error" }, { children: _jsx("div", Object.assign({ role: "status", className: "customerErrorMessage", "aria-live": "assertive" }, { children: _jsx("div", { children: errorMessage }) })) }))), isModalOpen && (_jsx(Stack.Item, Object.assign({ className: "customerSearchForm__row" }, { children: _jsx(Modal, Object.assign({ titleAriaId: "customerSearchModal", isOpen: isModalOpen, onDismiss: hideModal, isModeless: true, containerClassName: "customerSearchModal", dragOptions: isDraggable ? dragOptions : undefined }, { children: searchType === SearchType.Customer ? (_jsx(CustomerSearch, Object.assign({ customerSearchData: searchCriteria === null || searchCriteria === void 0 ? void 0 : searchCriteria.keyword, customerDataResultDispatch: resultDispatch, cancelDispatch: hideModal }, { children: _jsx(ElxIconButton, { text: "Cancel", onClick: hideModal, iconProps: { iconName: "cancel" }, style: { float: "right" } }) }))) : (_jsx(PartnerSearch, Object.assign({ partnerSearchData: searchCriteria === null || searchCriteria === void 0 ? void 0 : searchCriteria.keyword, partnerDataResultDispatch: resultDispatch, cancelDispatch: hideModal }, { children: _jsx(ElxIconButton, { text: "Cancel", onClick: hideModal, iconProps: { iconName: "cancel" }, style: { float: "right" } }) }))) })) }))), _jsx(Stack.Item, Object.assign({ className: "customerSearchForm__row" }, { children: _jsx(Checkbox, { className: "customerChkBox", label: searchType === SearchType.Customer
                        ? getLocalSpecificString("noCustomerFoundLabel")
                        : getLocalSpecificString("noPartnerFoundLabel"), checked: !suggestions, onChange: (_ev, checked) => {
                        const isManualMode = !!checked;
                        setIsManualModeSticky(isManualMode);
                        setSuggestions(!isManualMode);
                        setCompanyOrPartnerName("");
                        hideModal();
                        if (searchType === SearchType.Customer) {
                            const customerData = {
                                tpid: "",
                                msSalesID: isManualMode ? "0" : "",
                                accountNumber: "",
                                companyName: "",
                                country: "",
                                subsidiary: "",
                                salesRegion: "",
                                atuGroupName: "",
                                atuManagerAlias: "",
                                atuAccountExecutiveAlias: "",
                                segment: "",
                                subSegment: "",
                            };
                            resultDispatch({
                                customerData,
                                partnerData: {},
                            });
                        }
                        else {
                            const partnerData = {
                                partnerId: isManualMode ? "0" : "",
                                partnerName: "",
                                parentIdNumber: "",
                                parentName: "",
                                subsidiaryName: "",
                                segmentName: "",
                                subSegmentName: "",
                            };
                            resultDispatch({
                                partnerData,
                                customerData: {},
                            });
                        }
                    } }) }))] })));
};
export default CustomerSearchContainer;
